"use client";

import _slicedToArray from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { jsx } from 'react/jsx-runtime';
import { useContext, Component } from 'react';
import { usePresence } from '../../../components/AnimatePresence/use-presence.mjs';
import { LayoutGroupContext } from '../../../context/LayoutGroupContext.mjs';
import { SwitchLayoutGroupContext } from '../../../context/SwitchLayoutGroupContext.mjs';
import { globalProjectionState } from '../../../projection/node/state.mjs';
import { correctBorderRadius } from '../../../projection/styles/scale-border-radius.mjs';
import { correctBoxShadow } from '../../../projection/styles/scale-box-shadow.mjs';
import { addScaleCorrector } from '../../../projection/styles/scale-correction.mjs';
import { microtask } from '../../../frameloop/microtask.mjs';
import { frame } from '../../../frameloop/frame.mjs';
var MeasureLayoutWithContext = /*#__PURE__*/function (_Component) {
  _inherits(MeasureLayoutWithContext, _Component);
  var _super = _createSuper(MeasureLayoutWithContext);
  function MeasureLayoutWithContext() {
    _classCallCheck(this, MeasureLayoutWithContext);
    return _super.apply(this, arguments);
  }
  _createClass(MeasureLayoutWithContext, [{
    key: "componentDidMount",
    value:
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */
    function componentDidMount() {
      var _this = this;
      var _this$props = this.props,
        visualElement = _this$props.visualElement,
        layoutGroup = _this$props.layoutGroup,
        switchLayoutGroup = _this$props.switchLayoutGroup,
        layoutId = _this$props.layoutId;
      var projection = visualElement.projection;
      addScaleCorrector(defaultScaleCorrectors);
      if (projection) {
        if (layoutGroup.group) layoutGroup.group.add(projection);
        if (switchLayoutGroup && switchLayoutGroup.register && layoutId) {
          switchLayoutGroup.register(projection);
        }
        projection.root.didUpdate();
        projection.addEventListener("animationComplete", function () {
          _this.safeToRemove();
        });
        projection.setOptions(_objectSpread(_objectSpread({}, projection.options), {}, {
          onExitComplete: function onExitComplete() {
            return _this.safeToRemove();
          }
        }));
      }
      globalProjectionState.hasEverUpdated = true;
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var _this2 = this;
      var _this$props2 = this.props,
        layoutDependency = _this$props2.layoutDependency,
        visualElement = _this$props2.visualElement,
        drag = _this$props2.drag,
        isPresent = _this$props2.isPresent;
      var projection = visualElement.projection;
      if (!projection) return null;
      /**
       * TODO: We use this data in relegate to determine whether to
       * promote a previous element. There's no guarantee its presence data
       * will have updated by this point - if a bug like this arises it will
       * have to be that we markForRelegation and then find a new lead some other way,
       * perhaps in didUpdate
       */
      projection.isPresent = isPresent;
      if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined) {
        projection.willUpdate();
      } else {
        this.safeToRemove();
      }
      if (prevProps.isPresent !== isPresent) {
        if (isPresent) {
          projection.promote();
        } else if (!projection.relegate()) {
          /**
           * If there's another stack member taking over from this one,
           * it's in charge of the exit animation and therefore should
           * be in charge of the safe to remove. Otherwise we call it here.
           */
          frame.postRender(function () {
            var stack = projection.getStack();
            if (!stack || !stack.members.length) {
              _this2.safeToRemove();
            }
          });
        }
      }
      return null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this3 = this;
      var projection = this.props.visualElement.projection;
      if (projection) {
        projection.root.didUpdate();
        microtask.postRender(function () {
          if (!projection.currentAnimation && projection.isLead()) {
            _this3.safeToRemove();
          }
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props3 = this.props,
        visualElement = _this$props3.visualElement,
        layoutGroup = _this$props3.layoutGroup,
        promoteContext = _this$props3.switchLayoutGroup;
      var projection = visualElement.projection;
      if (projection) {
        projection.scheduleCheckAfterUnmount();
        if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
        if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
      }
    }
  }, {
    key: "safeToRemove",
    value: function safeToRemove() {
      var safeToRemove = this.props.safeToRemove;
      safeToRemove && safeToRemove();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return MeasureLayoutWithContext;
}(Component);
function MeasureLayout(props) {
  var _usePresence = usePresence(),
    _usePresence2 = _slicedToArray(_usePresence, 2),
    isPresent = _usePresence2[0],
    safeToRemove = _usePresence2[1];
  var layoutGroup = useContext(LayoutGroupContext);
  return jsx(MeasureLayoutWithContext, _objectSpread(_objectSpread({}, props), {}, {
    layoutGroup: layoutGroup,
    switchLayoutGroup: useContext(SwitchLayoutGroupContext),
    isPresent: isPresent,
    safeToRemove: safeToRemove
  }));
}
var defaultScaleCorrectors = {
  borderRadius: _objectSpread(_objectSpread({}, correctBorderRadius), {}, {
    applyTo: ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomLeftRadius", "borderBottomRightRadius"]
  }),
  borderTopLeftRadius: correctBorderRadius,
  borderTopRightRadius: correctBorderRadius,
  borderBottomLeftRadius: correctBorderRadius,
  borderBottomRightRadius: correctBorderRadius,
  boxShadow: correctBoxShadow
};
export { MeasureLayout };